import { render } from "./EditCommentListWidget.vue?vue&type=template&id=90916c42&ts=true"
import script from "./EditCommentListWidget.ts?vue&type=script&lang=ts&external"
export * from "./EditCommentListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__